<csvbox-button
  [licenseKey]="licenseKey"
  [onImport]="onData.bind(this)"
  [lazy]="true"
  [user]="user$ | async"
  [environment]="env"
>
  <ng-content></ng-content>
</csvbox-button>
